<template>
    <received-files-inbox></received-files-inbox>
</template>
<script>
import ReceivedFilesInbox from '../components/received-files-view/received-files-inbox'

export default {
    name: 'received-files-page',
    components: {
        ReceivedFilesInbox
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/received-files-page.vue